import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from 'react-router/lib/withRouter';
import multipay_logo from '../../assets/img/multipay-logo-highres.png'
import * as actions from '../actions';
import Alert from 'react-s-alert';
import _ from 'lodash';


const initState = {
		refno: '',
	}

class Payment extends Component{

	state = initState

	handleChangeInput = ({target}) => {
		const { name, value } = target;
		this.setState({[name]: value})
	}

	handleSeachAgain = (e) => {
		e.preventDefault();
		this.setState(initState);
		this.props.onGetPayments({});
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.getPayments(this.state);
	}

	handlePaymentPostback = (e) => {
		e.preventDefault();
		this.props.getPaymentPostback(this.state);
	}

	componentWillReceiveProps(nextProps){
		const { searchAgain } = nextProps;
		if(searchAgain !== this.props.searchAgain && searchAgain){
			this.setState(initState);
		}
	}

	render(){
		const { paymentInfo, is_waiting } = this.props;
		return(
			<div className="outer">
				{ is_waiting
	                ? <div className="loader-wrapper">
	                    <div className="load-content">
	                        <div className="loading loading--double"></div>
	                        <div className="text">Loading...</div>
	                    </div>
	                </div>
	                : null
	            }
		        <div className="table-wrapper">
		            <div className="table-row-wrapper">
		                <div className="table-cell-wrapper">
		                    <div className="inner-wrapper">
		                        <center>
		                            <img
		                            	role="presentation"
		                            	className="main-logo"
		                            	src={multipay_logo} />
		                        </center>
		                        <form onSubmit={this.handleSubmit}>
			                        <div className="box-wrapper">
			                            <div className="text-center">
			                                <div>
			                                    <label>Reference Number:</label>
			                                </div>
			                                <input
			                                	required
			                                	disabled={!_.isEmpty(paymentInfo)}
			                                	value={this.state.refno}
			                                	onChange={this.handleChangeInput}
			                                	type="text"
			                                	name="refno"
			                                	className="form-control form-control-payment"
			                                	placeholder="Enter Reference Number" />
			                            </div>
			                            { !_.isEmpty(paymentInfo)
			                            	? <table className="payment">
				                                <tbody>
				                                    <tr>
				                                        <td>Institution</td>
				                                        <td>{paymentInfo.institution ? paymentInfo.institution : ''}</td>
				                                    </tr>
				                                    <tr>
				                                        <td>Txn ID</td>
				                                        <td>{paymentInfo.txnid ? paymentInfo.txnid : ''}</td>
				                                    </tr>
				                                    <tr>
				                                        <td>Reference No.</td>
				                                        <td>{paymentInfo.refno ? paymentInfo.refno : ''}</td>
				                                    </tr>
				                                    <tr>
				                                        <td>Date</td>
				                                        <td>{paymentInfo.transaction_date ? paymentInfo.transaction_date : ''}</td>
				                                    </tr>
				                                    <tr>
				                                        <td>Status</td>
				                                        <td>{paymentInfo.status ? paymentInfo.status : ''}</td>
				                                    </tr>
				                                    <tr>
				                                        <td>Amount</td>
				                                        <td>
				                                        	<span className="amount">PHP {paymentInfo.amount ? paymentInfo.amount : ''}</span>
				                                        </td>
				                                    </tr>
				                                    <tr>
				                                        <td>Email</td>
				                                        <td>{paymentInfo.email ? paymentInfo.email : ''}</td>
				                                    </tr>
																						{paymentInfo.expired_at && (
																							<tr>
																									<td>Expiry</td>
																									<td>{paymentInfo.expired_at ? paymentInfo.expired_at : ''}</td>
																							</tr>
																						)}
				                                </tbody>
				                            </table>
				                            : null
			                            }
			                           	{/*<hr className="hr-payment"/>*/}
			                            { !_.isEmpty(paymentInfo)
			                            	? <div className="btn-margin">
			                            		{ paymentInfo.status !== 'PENDING'
					                                ? <button
					                                	onClick={this.handlePaymentPostback}
					                                	className="btn btn-payment btn-primary-success">
					                                	Re-Postback
					                                </button>
					                                : null
			                            		}{' '}
			                            		<button
				                                	onClick={this.handleSeachAgain}
				                                	className="btn btn-payment btn-primary-default">
				                                	Cancel
				                                </button>
				                            </div>
			                            	: <div className="btn-margin">
				                                <button
				                                	disabled={is_waiting}
				                                	className="btn btn-payment btn-payment-primary">
				                                	Validate
				                                </button>
				                            </div>
			                            }
			                        </div>
		                        </form>
		                    </div>
		                </div>
		            </div>
		        </div>
		        <Alert stack={{ limit: 3 }} effect="slide"/>
		    </div>
			);
	}
}

module.exports = withRouter(connect(
	(state, route) => {
        const { paymentInfo, searchAgain } = state.payment;
        const { is_waiting } = state.waiting;
		return{
			searchAgain,
        	paymentInfo,
        	is_waiting
		}
	}, actions
)(Payment))


/** WEBPACK FOOTER **
 ** ./src/payment/containers/Payment.js
 **/